import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Kinesiología Resuelta — Consulta Resuelta™';
// Preconnect to critical origins BEFORE React renders
const origins = [{
  href: 'https://res.cloudinary.com',
  crossOrigin: 'anonymous'
}, {
  href: 'https://cdn.magicpatterns.com',
  crossOrigin: 'anonymous'
}, {
  href: 'https://images.unsplash.com',
  crossOrigin: 'anonymous'
}];
origins.forEach(({
  href,
  crossOrigin
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = crossOrigin;
  document.head.appendChild(link);
});
// Preload hero image for faster LCP — must match the actual src in App.tsx
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_400/v1777593352/hf_20260430_234428_41cb3c68-981e-4c20-8031-afe469b66fa3-Photoroom_djwf2s.webp';
document.head.appendChild(preloadImg);
render(<App data-id="element-375" />, document.getElementById('root'));